// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3qBUU","label":"Section_label__152DV","contentWrap":"Section_contentWrap__C5K62","footer":"Section_footer__2j4Az","footerInner":"Section_footerInner__3nQ_-"};